export enum TemplateColumnCategory {
  NORMAL = "NORMAL",
  CUSTOM_FIELD = "CUSTOM_FIELD",
  FLEX_ROW = "FLEX_ROW",
  STOCK_BUDGET_ITEM = "STOCK_BUDGET_ITEM",
}
